import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getReportEmbedDataByReportId } from './powerBiService';

export const initialState = {
  loading: false,
  error: null,
  powerBiData: null,
};

export const getPowerBiReport = createAsyncThunk(
  'powerBiReports/getPowerBiReport',
  async ({ projectId, item }) => {
    let response;
    const { reportId, isShared, data } = item;
    if (isShared) {
      const parsedData = JSON.parse(data);
      response = await getReportEmbedDataByReportId(
        projectId,
        parsedData.ReportId
      );
    } else {
      response = await getReportEmbedDataByReportId(projectId, reportId);
    }
    return response;
  }
);

const getPowerBiReportSlice = createSlice({
  name: 'getPowerBiReport',
  initialState,
  reducers: {},
  extraReducers: {
    [getPowerBiReport.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getPowerBiReport.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.powerBiData = payload;
    },
    [getPowerBiReport.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
      state.powerBiData = null;
    },
  },
});

export const { reducer: getPowerBiReportReducer } = getPowerBiReportSlice;

export const getPowerBiReportSelector = (state) => state.getPowerBiReport;
